var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGolang(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.493,
    height: 39.035,
    viewBox: "0 0 102.493 39.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.909)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.394,396.03s33.826-3.647,35.767-4.236,19.542-2.53,19.542-2.53-.541-1.53-3.717-1.471-1.37.3-6.077.885-33.754,3.786-33.519,4.257-10.879.034-12,3.094Z",
    transform: "translate(-7.394 -387.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M82.491,442.91s1.9,2.066,18.293-.513c4.867-.5,6.074-.585,6.074-.585s15.359.558,17.314-3.269c-3.2-2.413-11.392.569-19.6,1.643-5.366.7-21.7.313-22.076,2.725Z",
    transform: "translate(-73.577 -431.709)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M433.687,21.761a59.5,59.5,0,0,0,9.81-3.4c4.155-2.012,4.879-1.033,4.879-1.033l.986,1.527s-6.739,10.168-9.568,12.328-12.063,9.718-17.6,7.289c-6.711-8.779,11.926-32.112,20.825-36.624,7.014-3.284,9.458-3.622,6.713,11.338-1.082,1.71-4.635.731-4.368.585.872-.477,2.777-8.319,1.945-9.129s-.8-.356-2.61,0c-2.626.509-21.631,16.017-19.759,29.02,8.278,3.824,16.764-11.518,16.764-11.518S439.3,24.01,434.5,23.4c-1.4-.179-.813-1.636-.813-1.636Z",
    transform: "translate(-370.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M648.684,14.773c-7.1-1.284-18.862,13.853-22.33,22.156-2.039,7.163-4.446,11.49-1.111,15,4,.329,10.618-.378,19.94-13.092,11.117-12.689,5.431-23.007,5.431-23.007-.887-.19-1.047-.9-1.929-1.058Zm-.37,4.328s3.047,4.538-5.895,17.31c-4.368,4.469-8.96,12.516-15.689,10.016.723-3.006,12.406-29.227,21.583-27.325Z",
    transform: "translate(-549.575 -12.952)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolang);
export default __webpack_public_path__ + "static/media/golang.1712652c323d9e5c61e4d1816d6de1e5.svg";
export { ForwardRef as ReactComponent };